import { requireDashboardOrigin } from "@playbrain/auth/server/dashboardOriginGuard"
import { serverRouteConfig } from "@server/server-route-config"
import { dashboardApiErrorMessage } from "@site-server/dashboard-api-errors"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const passwordResetInputSchema = z.object({
  email: z.string().email().max(254),
  locale: z.enum(["en", "ja"]).optional(),
})

export const Route = createFileRoute("/api/dashboard/auth/password-reset")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = passwordResetInputSchema.parse(await request.json())
            const { requestDashboardPasswordReset } = await import(
              "@api/features/dashboard-auth/password-reset/dashboardPasswordResetApi"
            )
            await requestDashboardPasswordReset({
              ...input,
              baseUrl: new URL(request.url).origin,
            })
            return Response.json({ sent: true })
          } catch (error) {
            return Response.json(
              {
                error: dashboardApiErrorMessage(error, "Could not send password reset."),
              },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
